module.exports = __webpack_public_path__ + "img/chanpindefen.e42ee5bc.png";